import { Button, Form, Input, Select, Drawer, Popover } from 'antd'
import React, { useState, useContext, useEffect } from 'react'
import { get } from 'lodash'
import _map from 'lodash/map'
import client from 'apollo'
import { FilterOutlined, DownloadOutlined } from '@ant-design/icons'
import './index.css'
import '../index.css'
import NoData from 'components/NoData'
import { AppContext } from 'AppContext'
// import DownloadReport from '../DownloadReport'
import {
  SP_CURRENT_POSITIONFO,
  GET_REPORT_CLIENT_USERS_FOR_STAFF,
} from '../graphql/Queries'
import PositionFOTable from './PositionFOTable'
import { GET_STRATEGY_LIST } from 'modules/Settings/graphql/Queries'
import Page404 from 'components/Page404'
import Loader from 'components/loaders/Loader'
import FilterBackButton from 'assets/images/new-images/filter-back-button.svg'
import PdfIcon from 'assets/images/new-images/pdficon.svg'
import ExcelIcon from 'assets/images/new-images/excelIcon.svg'
import { exportGraphAsPdf } from 'utils/Graph'
import { CSVLink } from 'react-csv'
import { getName, canUserExport, canUserDownload } from 'utils/User'
import CustomMeta from 'components/CustomMeta'

const { Option } = Select

export default function () {
  const [form] = Form.useForm()
  const [strategyList, setStrategyList] = useState([])
  const [open, setOpen] = useState(false)
  const {
    state: {
      isClient,
      isMobile,
      currentUser: { role, clientCode, userName, strategyCode },
      userPermissions,
    },
    dispatch,
  } = useContext(AppContext)

  const hasExport = canUserExport(userPermissions, isClient)
  const hasDownload = canUserDownload(userPermissions, isClient)
  const [filters, setFilters] = useState({
    clientCode: isClient ? clientCode || '' : '',
    userName: isClient ? userName || '' : '',
    strategyCode: isClient ? strategyCode || '' : '',
    strategy: '',
    script: '',
  })

  useEffect(() => {
    dispatch({ type: 'SELECTED_GROUP', data: undefined })
    dispatch({ type: 'SELECTED_STRATEGY', data: 'ILTS' })
  }, [dispatch])

  useEffect(() => {
    client
      .query({ query: GET_STRATEGY_LIST, fetchPolicy: 'network-only' })
      .then((res) => {
        setStrategyList(res.data.getStrategyList)
      })
  }, [])
  const [data, setData] = useState()
  const [clientListLoading, setClientListLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [staffData, setStaffData] = useState([])

  const loadClientUsers = () => {
    setClientListLoading(true)
    setError(false)
    client
      .query({
        query: GET_REPORT_CLIENT_USERS_FOR_STAFF,
        variables: { where: {}, limit: 1000000 },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        const users =
          res?.data?.getClientUsersForStaff?.users?.filter(
            (user) => user?.clientCode,
          ) || []
        setStaffData(users)
      })
      .catch((err) => {
        setError(err)
      })
      .finally(() => {
        setClientListLoading(false)
      })
  }

  useEffect(() => {
    if (!isClient) return

    setFilters((prevFilters) => {
      if (
        prevFilters?.clientCode === (clientCode || '') &&
        prevFilters?.userName === (userName || '') &&
        prevFilters?.strategyCode === (strategyCode || '')
      ) {
        return prevFilters
      }

      return {
        ...prevFilters,
        clientCode: clientCode || '',
        userName: userName || '',
        strategyCode: strategyCode || '',
      }
    })
  }, [clientCode, userName, strategyCode, isClient])

  const selectedClient =
    !isClient && filters?.clientCode
      ? staffData.find(
          (user) =>
            user?.clientCode === filters?.clientCode &&
            user?.userName === filters?.userName
        )
      : undefined

  useEffect(() => {
    if (isClient && !filters?.clientCode) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(false)
    const isAdminOrStaff = role === 'ADMIN' || role === 'STAFF'
    const reportUserName = isClient ? userName || '' : selectedClient?.userName || ''
    const reportStrategyCode = filters?.strategy
      ? filters?.strategy
      : isClient
        ? strategyCode || ''
        : selectedClient?.strategyCode || ''

    client
      .query({
        query: SP_CURRENT_POSITIONFO,
        variables: {
          where: {
            ...filters,
            clientCode: filters?.clientCode,
            userName: isAdminOrStaff && !filters?.clientCode ? '' : reportUserName,
            strategyCode: isAdminOrStaff && !filters?.clientCode && !filters?.strategy ? '' : reportStrategyCode,
          },
        },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setData(res?.data)
      })
      .catch((err) => {
        setError(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [filters, isClient, selectedClient, userName, strategyCode, role])

  if (loading) return <Loader />
  if (error) return <Page404 error={error} />

  let currentPositionFOBalanceData
  const spCurrentPositionFO = get(data, 'spCurrentPositionFO', [])
  const hasReportData = spCurrentPositionFO.length > 0
  currentPositionFOBalanceData = spCurrentPositionFO.map((EqBalance) => {
    return {
      ...EqBalance,
      Strike: Math.round(EqBalance.Strike),
      qty: Math.round(EqBalance.qty),
      Value: Math.round(EqBalance.Value),
      NetPrice: EqBalance.NetPrice,
    }
  })

  const child = [
    {
      title: 'Client Code',
      dataIndex: 'ClientCode',
      key: 'ClientCode',
      width: isMobile && 100,
      className: 'report-text',
    },
    {
      title: 'Strategy Code',
      dataIndex: 'StrategyCode',
      key: 'StrategyCode',
      width: isMobile && 150,
      className: 'report-numeric',
    },
    {
      title: 'Script',
      dataIndex: 'script',
      key: 'script',
      width: isMobile && 150,
      className: 'report-numeric-position-FO',
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
      width: isMobile && 100,
      className: 'report-numeric',
    },
    {
      title: 'Expiry Date',
      dataIndex: 'ExpiryDate',
      key: 'ExpiryDate',
      width: isMobile && 80,
      className: 'report-numeric',
    },
    {
      title: 'Strike',
      dataIndex: 'Strike',
      key: 'Strike',
      width: isMobile && 100,
      className: 'report-numeric',
    },
    {
      title: 'CP',
      dataIndex: 'CP',
      key: 'CP',
      width: isMobile && 100,
      className: 'report-numeric',
    },
    {
      title: 'qty',
      dataIndex: 'qty',
      key: 'qty',
      width: isMobile && 100,
      className: 'report-numeric',
    },
    {
      title: 'Value',
      dataIndex: 'Value',
      key: 'Value',
      width: isMobile && 100,
      className: 'report-numeric',
      render: (text) => text,
    },
    {
      title: 'NetPrice',
      dataIndex: 'NetPrice',
      key: 'NetPrice',
      width: isMobile && 100,
      className: 'report-numeric',
      render: (text) => text.toFixed(2),
    },
  ]

  const columns = [
    {
      title: 'FO Position Report',
      className: 'report-title main-title',
      children:
        role !== 'ADMIN'
          ? child
          : child?.filter((item) => item?.title !== 'Company'),
    },
  ]

  const onFinish = (values) => {
    const selectedUser = !isClient
      ? staffData.find((u) => u.userName === values?.clientCode)
      : null

    setFilters({
      ...values,
      clientCode: isClient ? clientCode || '' : (selectedUser?.clientCode || ''),
      userName: isClient ? userName || '' : (selectedUser?.userName || ''),
      strategyCode: isClient ? strategyCode || '' : (selectedUser?.strategyCode || ''),
      strategy: values.strategy ? values.strategy : '',
      script: values.script ? values.script : '',
    })
    setOpen(false)
  }

  let staticHtml = ``
  if (hasReportData) {
    staticHtml = `
<div class="ant-table-wrapper nlv-tracker-report">
  <div class="ant-spin-nested-loading">
    <div class="ant-spin-container">
      <div class="ant-table">
        <div class="ant-table-container">
          <div class="ant-table-content">
            <table style="table-layout: auto;">
              <colgroup>
                <col style="width: 60px; min-width: 60px;">
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col style="width: 200px; min-width: 200px;">
              </colgroup>
              <thead class="ant-table-thead">
                <tr>
                  <th colspan="14" class="ant-table-cell report-title main-title">FO Position Report</th>
                </tr>
                <tr>
                  <th class="ant-table-cell report-text">Client Code</th>
                  <th class="ant-table-cell report-text">StrategyCode</th>
                  <th class="ant-table-cell report-text">script</th>
                  <th class="ant-table-cell report-text">company</th>
                  <th class="ant-table-cell report-numeric">ExpiryDate</th>
                  <th class="ant-table-cell report-numeric">Strike</th>
                  <th class="ant-table-cell report-text">CP</th>
                  <th class="ant-table-cell report-numeric">qty</th>
                  <th class="ant-table-cell report-numeric">Value</th>
                  <th class="ant-table-cell report-numeric">NetPrice</th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">`
    data.spCurrentPositionFO.forEach((row) => {
      const {
        ClientCode,
        StrategyCode,
        script,
        company,
        ExpiryDate,
        Strike,
        CP,
        qty,
        Value,
        NetPrice,
      } = row
      staticHtml = `${staticHtml}
                <tr data-row-key="KYP" class="ant-table-row ant-table-row-level-0">
                  <td class="ant-table-cell report-text">${ClientCode} </td>
                  <td class="ant-table-cell report-text">${StrategyCode}</td>
                  <td class="ant-table-cell report-text">${script}</td>
                  <td class="ant-table-cell report-text">${company}</td>
                  <td class="ant-table-cell report-numeric">${ExpiryDate}</td>
                  <td class="ant-table-cell report-numeric">${Strike}</td>
                  <td class="ant-table-cell report-text">${CP}</td>
                  <td class="ant-table-cell report-numeric">${qty}</td>
                  <td class="ant-table-cell report-numeric">${Math.round(
                    Value
                  )}</td>
                  <td class="ant-table-cell report-numeric">${NetPrice.toFixed(
                    2
                  )}</td>
                </tr>`
    })
    staticHtml = `${staticHtml}
              </tbody >
            </table >
          </div >
        </div >
      </div >
    </div >
  </div >
</div >
      `
  }

  const showDrawer = () => {
    if (!isClient && !staffData.length && !clientListLoading) {
      loadClientUsers()
    }
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const handleDownloadPdf = () => {
    exportGraphAsPdf(
      'current-positionFO',
      'SP_CURRENT_POSITIONFO_PDF',
      staticHtml,
      true
    ).finally(() =>
      console.log(' ====== current-positionFO downloaded ====== ')
    )
  }

  const content = (
    <div style={{ width: '100px' }}>
      {hasDownload && (
        <div
          onClick={handleDownloadPdf}
          style={{
            marginBottom: `${isMobile ? '0px' : '10px'}`,
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '24px',
            textAlign: 'left',
            color: ' #000',
            cursor: 'pointer',
          }}
        >
          <img src={PdfIcon} style={{ marginRight: '10px' }} alt='pdf' /> PDF
        </div>
      )}

      {hasExport && (
        <CSVLink
          style={{ paddingRight: 0 }}
          data={spCurrentPositionFO?.map((item) => {
            return {
              ...item,
              Value: Math.round(item?.Value),
              NetPrice: item?.NetPrice?.toFixed(2),
            }
          })}
          className='csv-btn'
          filename={'current-positionFO'}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              marginBottom: `${isMobile ? '0px' : '10px'}`,
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '24px',
              textAlign: 'left',
              color: ' #000',
              cursor: 'pointer',
            }}
          >
            <img src={ExcelIcon} style={{ marginRight: '10px' }} alt='excel' />{' '}
            Excel
          </div>
        </CSVLink>
      )}
    </div>
  )
  return (
    <>
      <CustomMeta title='Report | Position FO' />
      <Drawer
        title={null}
        headerStyle={{ display: 'none' }}
        closable={false}
        placement='right'
        onClose={onClose}
        visible={open}
        width={472}
      >
        <div className='Filter_Form'>
          <div onClick={onClose}>
            <img src={FilterBackButton} alt='FilterBackButton' />
          </div>
          <div className='filter_panel_heading'>Filter</div>
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          name='advanced_search'
          layout='vertical'
          className='client-detail-form'
        >
          <div className='filter_Form_div_Container'>
            {!isClient && (
              <Form.Item
                name='clientCode'
                label='Select Client Code'
              >
                <Select
                  style={{ width: '100%' }}
                  getPopupContainer={(trigger) => trigger.parentElement}
                  className='display-field'
                  showSearch
                  loading={clientListLoading}
                  placeholder='Select Client Code'
                  optionFilterProp='title'
                  filterOption={(input, option) => {
                    const searchableValues = [option?.title, option?.value]
                    return searchableValues.some((value) =>
                      value?.toLowerCase().includes(input.toLowerCase())
                    )
                  }}
                >
                  {!clientListLoading &&
                    staffData &&
                    staffData.map((user, key) => {
                      return (
                        <Option
                          key={key}
                          value={user?.userName}
                          title={`${user?.clientCode} - ${getName(user)} ${user?.plan?.name ? `(${user?.plan?.name})` : ''}`}
                        >
                          {user?.clientCode}-{getName(user)}{' '}
                          {user?.plan?.name ? `(${user?.plan?.name})` : ''}
                        </Option>
                      )
                    })}
                </Select>
              </Form.Item>
            )}
            <Form.Item name='script' label='script'>
              <Input placeholder='Enter script' style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name='strategy' label='strategy'>
              <Select
                className='gx-mr-3 gx-select-sm'
                getPopupContainer={(trigger) => trigger.parentElement}
                onChange={(e) =>
                  dispatch({ type: 'SELECTED_STRATEGY', data: e })
                }
              >
                {_map(strategyList, (strategy, key) => {
                  const { StrategyName, StrategyCode } = strategy
                  return (
                    <Option value={StrategyCode} key={key}>
                      {StrategyName}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </div>
          <div className='filter_panel_button'>
            <Button
              onClick={() => {
                form.resetFields()
                setOpen(false)
                setFilters({
                  clientCode: isClient ? clientCode || '' : '',
                  userName: isClient ? userName || '' : '',
                  strategyCode: isClient ? strategyCode || '' : '',
                  strategy: '',
                  script: '',
                })
              }}
            >
              Clear
            </Button>
            <Button type='primary' htmlType='submit'>
              Search
            </Button>
          </div>
        </Form>
      </Drawer>
      {error ? (
        <Page404 error={error} isShow={false} />
      ) : (
        <div className='report_Container'>
          <div className='container_Header'>
            <div className='report_Heading'>Position FO</div>

            <div className='container_Export_Popover'>
              {(hasExport || hasDownload) && !error && hasReportData ? (
                <Popover content={content} placement='bottom' trigger='click'>
                  <div className='container_Export_Popover'>
                    <Button>
                      Export{' '}
                      <DownloadOutlined
                        color='#AF0000'
                        style={{ fontSize: '16px' }}
                      />
                    </Button>
                  </div>
                </Popover>
              ) : (
                ''
              )}

              <Button
                style={{
                  color: '#000000',
                  border: '1px solid #919EAB52',

                  backgroundColor: 'white',
                }}
                onClick={showDrawer}
              >
                Filter{' '}
                <FilterOutlined color='#000000' style={{ fontSize: '16px' }} />
              </Button>
            </div>
          </div>
          <div
            className='report-table-wrapper'
            id='SP_CURRENT_POSITIONFO_PDF'
          >
            {hasReportData ? (
              <PositionFOTable
                filters={filters}
                data={currentPositionFOBalanceData}
                columns={columns}
                loading={loading}
              />
            ) : (
              <NoData />
            )}
          </div>
        </div>
      )}
    </>
  )
}
